var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('b-alert',{attrs:{"show":!!_vm.errorHandlingMessage,"variant":"danger","dismissible":""}},[_vm._v(_vm._s(_vm.errorHandlingMessage))]),_c('b-button',_vm._b({},'b-button',_vm.localBtnProps,false),[_vm._v(_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }